export default {
      id: "shevron-right-usage",
      viewBox: "0 0 8 12",
      url: __webpack_public_path__ + "icons.svg#shevron-right",
      toString: function () {
        return this.url;
      }
    }